import { createSlice } from "@reduxjs/toolkit";

const subjectSlice = createSlice({
    name: "filteredSubject",
    initialState: [],
    reducers: {
        filteredSubject: (state, action) => {
            return action.payload
        },
    },
});

export const { filteredSubject } = subjectSlice.actions;
export default subjectSlice.reducer;
